<div class="card card-custom card-stretch gutter-b">
    <div class="card-header align-items-center border-0 mt-4">
        Temas
        <nav  class="toolbar toolbar-icon align-content-center">
            <div class="rounded-pill d-flex align-items-center">
          

              <a type="button" class="btn btn-hover" routerLink="/CompanySettingsList">
                <i class="me-1 sidebar-text fa-solid fa-arrow-left"></i>
                <span class="types-custom__letter">Atrás</span>
              </a>

              <a style="cursor: pointer;" type="button" class="btn btn-hover" >
                <i style="cursor: pointer;" class="me-1 sidebar-text dx-icon-save" (click)="save()" > <span class="types-custom__letter" style="font-size: large;">Guardar</span></i>
              </a>
    
              <!-- <dx-toolbar>
                <dxi-item
                  location="before"
                  widget="dxButton"
                  [options]="addButtonOptions"
                >
                </dxi-item>
              </dx-toolbar> -->
            </div>
        </nav>
    </div>

    <div class="card-body pt-4">

        <div id="divCompanySettings">
            <dx-form [showColonAfterLabel]="false" [colCount]="1" [elementAttr]="{ id: formId }" [(formData)]="themeData" [showValidationSummary]="true" labelLocation="top">
                <dxi-item itemType="group" [colCount]="4">
                    <dxi-item dataField="code" editorType="dxNumberBox" [disabled]="this.modeEdit">
                        <dxo-label class="font-weight-bold" text="Código"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Código Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="name">
                        <dxo-label class="font-weight-bold" text="Nombre"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Nombre Obligatorio'"></dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
                <dxi-item [visible]="coloresself" itemType="group" caption="Colores" [colCount]="4">
                    <dxi-item dataField="assets.gridHeaderColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Cabezal Grilla"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.gridHeaderTextColor" editorType="dxColorBox" title="Aquí va el titulo">
                        <dxo-label class="font-weight-bold" text="Texto Cabezal Grilla"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.labelColor" editorType="dxColorBox" title="Select House Price Range">
                        <dxo-label class="font-weight-bold" text="Etiqueta" title="Aca va el titulo"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.primaryColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Primario"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.primaryTextColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Texto Primario"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.primaryButtonColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Botón Primario"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.primaryButtonTextColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Texto Botón Primario"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.secundaryColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Secundario"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.secundaryTextColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Texto Secundario"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.secundaryButtonColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Botón Secundario"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.secundaryButtonTextColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Texto Botón Secundario"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.titleColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Título"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.titleTextColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Texto Título"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.subTitleColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Subtitulo"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="assets.borderColor" editorType="dxColorBox">
                        <dxo-label class="font-weight-bold" text="Borde"> </dxo-label>
                        <dxi-validation-rule type="required" [message]="'Color Obligatorio'"></dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
                <dxi-item>
                    <dx-check-box [value]="false" (onValueChanged)="checkBoxcoloresSelf($event)" text="Colores SelfService">
                    </dx-check-box>
                </dxi-item>
                <dxi-item>
                    <dx-check-box [value]="false" (onValueChanged)="checkBoxSelf($event)" text="Imagenes SelfService"[visible]="Visible">
                    </dx-check-box>
                </dxi-item>

                <dxi-item>
                    <dx-check-box [value]="false" (onValueChanged)="checkBoxSeven($event)" text="Imagenes Seven ERP"[visible]="Visible">
                    </dx-check-box>
                </dxi-item>

                <dxi-item>
                    <dx-check-box [value]="false" (onValueChanged)="checkBoxPos($event)" text="Imagenes POS"[visible]="Visible">
                    </dx-check-box>
                </dxi-item>

                <dxi-item itemType="group" caption="Imagenes SelfService(maximo 5 Imagenes)" name="ImageSelf" [visible]="isImageVisible">

                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClick($event,'image1')" id="image1" class="form-control my-1">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClick($event, 'image2')" id="image2" class="form-control my-1">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClick($event, 'image3')" id="image3" class="form-control my-1">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClick($event, 'image4')" id="image4" class="form-control my-1">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClick($event, 'image5')" id="image5" class="form-control my-1">
                        </td>
                    </tr>

                </dxi-item>

                <dxi-item itemType="group" caption="Imagenes Seven(maximo 5 Imagenes)" name="ImageSelf" [visible]="isImageVisibleSeven">

                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClick($event,'image1')" id="image1" class="form-control my-1">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClick($event, 'image2')" id="image2" class="form-control my-1">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClick($event, 'image3')" id="image3" class="form-control my-1">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClick($event, 'image4')" id="image4" class="form-control my-1">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClick($event, 'image5')" id="image5" class="form-control my-1">
                        </td>
                    </tr>

                </dxi-item>
                <dxi-item [visible]="isImageVisiblePos">
                    <tr>
                        <td>
                            <input type="file" accept="image/*" (input)="updateClickPos($event)" class="form-control my-1">
                        </td>
                    </tr>
                    <dx-data-grid id="gridContainer"   [dataSource]="ListImagePos"  [columns]="['nombreImagen']" [showBorders]="true">
                    </dx-data-grid>
                </dxi-item>
            </dx-form>
        </div>
        <dx-load-panel #loadPanelCompanySettings shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#divCompanySettings' }" [(visible)]="this.loading" [showIndicator]="true" [showPane]="true" [shading]="true" [message]="'Cargando...'" [closeOnOutsideClick]="false">
        </dx-load-panel>
    </div>
</div>